<script lang="ts">
    import {
        REWARDS_REFERRAL_SHARE_CHANNELS,
        REWARDS_REFERRAL_SHARE_TOOLTIP,
    } from "@apps/rewards/modules/ReferralProgram/constants";
    import { REWARDS_REFERRAL_SHARE_ICONS } from "@apps/rewards/modules/ReferralProgram/icons";
    import type { REWARDS_REFERRAL_SHARE_CHANNELS_TYPE } from "@apps/rewards/modules/ReferralProgram/types";
    import type { RewardsStorefrontValuesSettingsEntity } from "@apps/rewards/modules/StorefrontValues/models/RewardsStorefrontValuesEntities";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import EmailShareIcon from "@apps/rewards/widgets/rewards_popup_root_widget/components/icons/SocialShareIcons/EmailShareIcon.svelte";

    import T from "@components/T.svelte";
    import TooltipActivator from "@components/Tooltip/TooltipActivator.svelte";
    import Text from "@components/Typography/Text.svelte";

    import RewardsIconButton from "../Buttons/RewardsIconButton.svelte";
    import RewardsIcon from "../RewardsIcon.svelte";
    import RewardsLink from "../RewardsLink.svelte";

    //Props
    export let referralShareChannels: RewardsStorefrontValuesSettingsEntity["referralShareChannels"];
    export let receiverMailToLink: string;
    export let namespace: TranslationNamespaces;
    export let onWindowOpen: (
        channelType: REWARDS_REFERRAL_SHARE_CHANNELS_TYPE
    ) => void;
</script>

<ul class="gw-rd-referral-share gw-list-reset-default-styles">
    {#each referralShareChannels || [] as { channelType }, index (index)}
        <li>
            <TooltipActivator position="bottom" theme="light">
                {#if channelType === REWARDS_REFERRAL_SHARE_CHANNELS.emailShare}
                    <RewardsLink
                        href={receiverMailToLink}
                        ariaLabel={`Share referral with ${channelType}`}
                    >
                        <RewardsIcon
                            class="gw-rd-referral-share__icon"
                            size="large"
                        >
                            <EmailShareIcon />
                        </RewardsIcon>
                    </RewardsLink>
                {:else}
                    <RewardsIconButton
                        ariaLabel={`Share referral with ${channelType}`}
                        on:click={() => onWindowOpen(channelType)}
                    >
                        <RewardsIcon
                            class="gw-rd-referral-share__icon"
                            size="large"
                        >
                            <svelte:component
                                this={REWARDS_REFERRAL_SHARE_ICONS[channelType]}
                            />
                        </RewardsIcon>
                    </RewardsIconButton>
                {/if}
                <Text
                    slot="content"
                    component="span"
                    variant="secondary"
                    size="sm"
                >
                    <T
                        {namespace}
                        translationKey={REWARDS_REFERRAL_SHARE_TOOLTIP[
                            channelType
                        ]}
                    />
                </Text>
            </TooltipActivator>
        </li>
    {/each}
</ul>

<style lang="postcss">
    .gw-rd-referral-share {
        display: flex;
        justify-content: center;
        gap: var(--gw-rd-space-6);

        :global(.gw-rd-link) {
            display: flex;
        }

        :global(&__icon:hover path) {
            opacity: 0.8;
        }
    }
</style>
